import {ReactComponent as InfoIcon} from "../../../../core/ui/icon/Info.svg";

import "./_swap-form-info-message.scss";

import classNames from "classnames";

import Typography from "../../../../component/typography/Typography";

interface SwapFormInfoMessageProps {
  message: string;
  customClassName?: string;
}

function SwapFormInfoMessage({message, customClassName}: SwapFormInfoMessageProps) {
  return (
    <div
      className={classNames(
        "swap-form-info-message",
        "is-vertically-centered",
        customClassName
      )}>
      <InfoIcon />

      <Typography textColor={"text-gray-lighter"} fontWeight={"medium"}>
        {message}
      </Typography>
    </div>
  );
}

export default SwapFormInfoMessage;
